/*
* Copyright(c) 2018. Synergy Systems & Solutions. @link : http://s3india.com 
*
* @module : QuestionService
* @file : QuestionService.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of QuestionService
*
* Created on : 10-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 19-Oct-2019
*/
import axios from 'axios';
const API_URL = 'https://quiz.wanitsch.ch/quiz/quiz_app.php';

class QuestionService
{
	async sendAnswer(question_id,answer_id)
	{
		const url = `${API_URL}`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		let session_id = sessionStorage.getItem('session_id');
		let formData  = new FormData();
		formData.append('token','');
		formData.append('command','questions');
		formData.append('question_id',question_id);
		formData.append('answer_id',answer_id);
		formData.append('session_id',session_id);
		return axios({
			url:url,
			method: 'post',
			data: formData,
			config:{headers:headers}
		}).then(function(response) {
			return response.data;
		}).catch(function(response) {
			return response;
		});
	}

	async getPrevQuestions(question_id)
	{
		const url = `${API_URL}`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		let session_id = sessionStorage.getItem('session_id');
		let formData  = new FormData();
		formData.append('token','');
		formData.append('command','get_prev_questions');
		formData.append('question_id',question_id);
		formData.append('session_id',session_id);
		return axios({
			url:url,
			method: 'post',
			data: formData,
			config:{headers:headers}
		}).then(function(response) {
			return response.data;
		}).catch(function(response) {
			return response;
		});
	}
	
}
export default QuestionService;